<template>
  <div class="shadow-base p-5 rounded-[20px] my-2">
    <slot></slot>
  </div>
</template>
